export const Z_MODAL = 6800;
export const Z_OVERLAY = 8000;
export const Z_POPOVER = 9000;
export const Z_DATE_PICKER = 10000;
